import {IController} from "angular";
import * as angular from "angular";
import {Expense} from "../../models/expenses.model";

import {ExpenseStatus} from "../../types/expenses-status.type";
import {LocationType} from "../../../commons/types/location.type";


export class ExpensesTableRowCtrl implements IController {
  expense: Expense;
  columns: any;
  isSelected: boolean;
  onToggle: any;
  onApproveExpense: Function;
  onDeclineExpenses: Function;
  onEditExpense: Function;
  onDeleteExpense:Function;
  onTimeLineClicked:Function;
  onDownloadClicked: Function;

  public expensesRef: any;
  public iconByStatusMap: any;
  public locationActiveTooltip: boolean;

  public taskColorByPurpose:any;
  public expenseStatusesTypes: typeof ExpenseStatus = ExpenseStatus;
  public locationTypes:any;

  constructor(private $expenses, private tasksConstants) {
    this.iconByStatusMap = {};
    this.iconByStatusMap[ExpenseStatus.PENDING] = 'hold'
    this.iconByStatusMap[ExpenseStatus.APPROVED] = 'check-circle-outline'
    this.iconByStatusMap[ExpenseStatus.DECLINED] = 'close-circle-outline'
    this.expensesRef = this.$expenses();
    this.taskColorByPurpose = this.tasksConstants.typesToColor;
    this.locationTypes = LocationType;
  }


  $onInit() {
    this.locationActiveTooltip = false;
  };

  $onChanges(changes) {
    if (changes.expense && !changes.expense.isFirstChange()) {
      this.$onInit();
    }

  };

}

angular
  .module('bringoz.admin.expenses')
  .component('expensesTableRow', {
    bindings: {
      expense: '<',
      columns: '<',
      isSelected: '<',
      show: '<',
      onToggle: '&',
      onApproveExpense: '&',
      onDeclineExpenses: '&',
      onEditExpense: '&',
      onDeleteExpense: '&',
      onTimeLineClicked: '&',
      onDownloadClicked: '&'
    },
    template: require('./expenses-table-row.html').default,
    controller: ExpensesTableRowCtrl
  });
